import { html, View } from 'rune-ts';
import { CardProductError } from '@services/MarppleShop/renderApp/pages/Curation/components/CardProductView.ts';

type TProps = {
  type: 'Shipping' | 'Fire' | 'Bag-line' | 'Bag-Fill' | 'Clock';
};

/**
 * https://www.figma.com/design/J3pxvmlv167DXuLToyL3Mg/%EC%83%81%ED%92%88-%EC%B9%B4%EB%93%9C-UI?node-id=368-190512&m=dev
 */
export class IconView extends View<TProps> {
  protected override template({ type }: TProps) {
    if (type === 'Shipping') {
      return html`<svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 10 10"
        fill="none"
      >
        <g clip-path="url(#clip0_368_190513)">
          <path
            d="M3.72583 8.33366C3.74 8.40116 3.75 8.47033 3.75 8.54199C3.75 9.11741 3.28375 9.58366 2.70833 9.58366C2.13292 9.58366 1.66667 9.11741 1.66667 8.54199C1.66667 8.47033 1.67667 8.40116 1.69083 8.33366H3.72583ZM6.27375 8.33366C6.25958 8.40116 6.24958 8.47033 6.24958 8.54199C6.24958 9.11741 6.71583 9.58366 7.29125 9.58366C7.86667 9.58366 8.33292 9.11741 8.33292 8.54199C8.33292 8.47033 8.32292 8.40116 8.30875 8.33366H6.27375ZM7.91625 2.08366H7.08292V5.41699H9.99958V4.16699C9.99958 3.01658 9.06667 2.08366 7.91625 2.08366ZM7.08292 7.50033H8.33292C9.25333 7.50033 9.99958 6.75408 9.99958 5.83366V5.41699H7.08292V7.50033ZM6.24958 2.08366V7.50033H1.66667C0.74625 7.50033 0 6.75408 0 5.83366V2.08366C0 1.16324 0.74625 0.416992 1.66667 0.416992H4.58333C5.50375 0.416992 6.24958 1.16324 6.24958 2.08366ZM4.5025 3.68574C4.38625 3.46866 4.16042 3.33366 3.91417 3.33366H2.6525L3.47125 2.10658C3.59917 1.91533 3.5475 1.65658 3.35583 1.52866C3.16458 1.40074 2.90625 1.45241 2.77792 1.64408C2.77792 1.64408 1.70708 3.25991 1.695 3.29949C1.63375 3.50199 1.6725 3.72491 1.79875 3.89533C1.92542 4.06533 2.12708 4.16699 2.33917 4.16699H3.60375L2.77917 5.39241C2.65042 5.58324 2.70083 5.84241 2.89208 5.97074C2.96375 6.01908 3.04417 6.04199 3.12458 6.04199C3.25833 6.04199 3.39042 5.97783 3.47042 5.85824L4.47167 4.37116C4.6075 4.16574 4.61917 3.90283 4.5025 3.68574Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_368_190513">
            <rect width="10" height="10" fill="white" />
          </clipPath>
        </defs>
      </svg>`;
    } else if (type === 'Fire') {
      return html`<svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 10 10"
        fill="none"
      >
        <g clip-path="url(#clip0_368_190515)">
          <path
            d="M7.54041 3.56145C6.76541 2.92145 5.84541 2.23645 6.37541 0.471451C6.45541 0.211451 6.23541 -0.0485495 5.97041 0.00645047C5.08541 0.18645 3.39541 1.27145 3.31041 3.18145C3.25041 4.53145 3.67541 5.18645 3.97041 6.00145C4.14041 6.47145 3.63541 6.81645 3.19541 6.57645C2.39041 6.13645 2.02041 5.46145 1.91041 4.46645C1.88541 4.22145 1.55541 4.15145 1.44541 4.37645C1.12041 5.05645 0.985405 5.84645 1.11541 6.67145C1.37541 8.39645 2.81041 9.76645 4.54041 9.96645C6.92041 10.2365 8.93541 8.84645 8.93541 6.52145C8.93541 5.71645 8.81041 4.61645 7.53541 3.56645L7.54041 3.56145Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_368_190515">
            <rect width="10" height="10" fill="white" />
          </clipPath>
        </defs>
      </svg>`;
    } else if (type === 'Bag-line') {
      return html`<svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 10 10"
        fill="none"
      >
        <path
          d="M2.29199 3.13867H7.70801L8.53516 9.18066V9.18164L8.53418 9.18262H1.46582L1.46484 9.18164V9.18066L2.29199 3.13965V3.13867Z"
          fill="currentColor"
          stroke-width="0.929794"
        />
      </svg>`;
    } else if (type === 'Bag-Fill') {
      return html`<svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 10 10"
        fill="none"
      >
        <path
          d="M7.7724 3.31638C7.74393 3.11298 7.57308 2.96654 7.36968 2.96654H6.37306V2.30755C6.37306 1.55093 5.75475 0.932617 4.99813 0.932617C4.24151 0.932617 3.62319 1.55093 3.62319 2.30755V2.96654H2.62657C2.42318 2.96654 2.25233 3.11705 2.22385 3.31638L1.49978 8.60458C1.46723 8.84865 1.65436 9.06832 1.90249 9.06832H8.08969C8.33783 9.06832 8.52495 8.84865 8.49241 8.60458L7.76833 3.31638H7.7724ZM4.3432 2.30755C4.3432 1.94144 4.64016 1.64856 5.0022 1.64856C5.36423 1.64856 5.66119 1.94551 5.66119 2.30755V2.96654H4.33914V2.30755H4.3432Z"
          fill="currentColor"
        />
      </svg>`;
    } else if (type === 'Clock') {
      return html`<svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 10 10"
        fill="none"
      >
        <path
          d="M5 0.5C2.516 0.5 0.5 2.516 0.5 5C0.5 7.484 2.516 9.5 5 9.5C7.484 9.5 9.5 7.484 9.5 5C9.5 2.516 7.484 0.5 5 0.5ZM5.396 5.207L3.3215 6.6605C3.254 6.71 3.173 6.7325 3.0965 6.7325C2.9705 6.7325 2.849 6.674 2.7725 6.566C2.6465 6.386 2.6915 6.143 2.867 6.017L4.604 4.7975V2.6735C4.604 2.4575 4.7795 2.2775 5 2.2775C5.2205 2.2775 5.396 2.453 5.396 2.6735V5.207Z"
          fill="currentColor"
        />
      </svg>`;
    } else {
      throw new CardProductError();
    }
  }
}
